import type { ProcessorCreatePayload } from "@/customTypings/processor/Processor";
import type { ProcessorDeletedRestoreAvailableConflict } from "@/utils/processor/processorCreateConflict";
import {
    PROCESSOR_CREATE_CONFLICT,
    ProcessorCreateConflictError,
    isProcessorDeletedRestoreAvailableConflict,
} from "@/utils/processor/processorCreateConflict";
import { createPayloadSpreadRestoreConfig } from "./createPayloadSpreadRestoreConfig";

export function createProcessorRestoreConfig<TDetail extends { id: string }>(options: {
    restoreDeletedWithCreateValues: (payload: ProcessorCreatePayload & { id: string }) => Promise<TDetail>;
    onRestored: (detail: TDetail) => void;
}) {
    return createPayloadSpreadRestoreConfig<
        ProcessorDeletedRestoreAvailableConflict,
        ProcessorCreatePayload,
        ProcessorCreatePayload & { id: string },
        TDetail,
        ProcessorCreateConflictError
    >({
        ConflictErrorClass: ProcessorCreateConflictError,
        isRestoreAvailable: isProcessorDeletedRestoreAvailableConflict,
        deletedRestoreAvailableCode: PROCESSOR_CREATE_CONFLICT.deletedRestoreAvailable,
        modalTitle: "Restore deleted Processor?",
        modalBody: () =>
            "A deleted Processor matching these details already exists. Restore it using the details you entered?",
        successLabel: (conflict) => conflict.existingName,
        restoreDeletedWithCreateValues: options.restoreDeletedWithCreateValues,
        onRestored: (detail) => options.onRestored(detail),
    });
}
